import React from 'react';
import DatePickerLibrary from 'react-datepicker';
import './DatePicker.css';
import CaretIcon from '../../icons/utility/CaretIcon';
const DatePicker = (props) => {
    const { className = '', showTimeSelectOnly, ...rest } = props;
    const renderDayContents = (day) => {
        return React.createElement("div", { className: "react-datepicker__day--custom" }, day);
    };
    const icon = showTimeSelectOnly
        ? 'react-datepicker__input--custom-time'
        : 'react-datepicker__input--custom-calendar';
    return (React.createElement("div", { id: "hero-date-picker" },
        React.createElement(DatePickerLibrary, { ...rest, showTimeSelectOnly: showTimeSelectOnly, customInput: React.createElement("input", { type: "text", className: `${className} date-picker-library-input ${icon}` }), renderDayContents: renderDayContents, renderCustomHeader: ({ monthDate, customHeaderCount, decreaseMonth, increaseMonth }) => (React.createElement("div", { className: "react-datepicker__navigation--wrapper" },
                React.createElement("button", { type: "button", "aria-label": "Previous Month", className: 'react-datepicker__navigation react-datepicker__navigation--previous', style: customHeaderCount === 1 ? { visibility: 'hidden' } : {}, onClick: decreaseMonth },
                    React.createElement(CaretIcon, { direction: "backward", type: "utility", size: "small" })),
                React.createElement("div", { className: "react-datepicker__current-month" }, monthDate.toLocaleString('en-US', {
                    month: 'long',
                    year: 'numeric'
                })),
                React.createElement("button", { type: "button", "aria-label": "Next Month", className: 'react-datepicker__navigation react-datepicker__navigation--next', style: customHeaderCount === 1 ? { visibility: 'hidden' } : {}, onClick: increaseMonth },
                    React.createElement(CaretIcon, { direction: "forward", type: "utility", size: "small" })))) })));
};
export default DatePicker;
//# sourceMappingURL=index.js.map